import { Card } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const PillSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('h-9 w-44 flex-row items-center gap-3 rounded-control px-3 py-0', className);

	// Render
	return (
		<Card className={rootClassName}>
			<Skeleton className='size-3 shrink-0' />
			<Skeleton className='w-24' />
			<Skeleton className='ml-auto w-4' />
		</Card>
	);
};
export { PillSkeleton };
// Docs:
// https://github.com/dvtng/react-loading-s#readme
